import state from './boschpanelpoint.state'
import mutations from './boschpanelpoint.mutations'
import actions from './boschpanelpoint.actions'

export default {
  state,
  mutations,
  actions
}
